import React from 'react';
import Textarea from 'react-textarea-autosize';

import TooltipValidator from './TooltipValidator.jsx';

import './style.scss';

let it = 0;

export const merge = {
  TOP: 'top',
  BOTTOM: 'bottom'
};

export default (field) => {
  const name = 'i' + (field.input.name || it++);
  const id = (field.id ? field.id : `${field.meta.form}_${name}`).replace(/\./g, '_');
  const type = (field.type || '').toLowerCase();

  const classes = [];
  if (typeof field.className === 'string') {
    classes.push(field.className);
  }
  if (field.meta.visited || !field.meta.pristine || field.meta.submitFailed) {
    classes.push(field.meta.valid ? 'is-valid' : 'is-invalid');
  }
  const isCheckbox = (type === 'checkbox' || type === 'radio');
  if (!isCheckbox) {
    classes.push('form-control');
  }

  const mergeClasses = ['form-group'];
  if (field.merge === merge.TOP) {
    mergeClasses.push('merge-top');
  } else if (field.merge === merge.BOTTOM) {
    mergeClasses.push('merge-bottom');
  }
  if (typeof field.wrapperClassName === 'string') {
    mergeClasses.push(field.wrapperClassName);
  }

  if (field.autoComplete) {
    field.input.autoComplete = field.autoComplete;
  }
  const spaceBeforeLabel = field.spaceBeforeLabel !== false;
  const className = classes.join(' ');

  return (
    <div className={mergeClasses.join(' ')}>
      {!isCheckbox && field.label && <label htmlFor={id}>{field.label}</label>}
      {field.counter !== undefined && <small className="helper">{field.counter} caractère(s) restant(s)</small>}
      <TooltipValidator field={field} target={field.errorTarget || id} checkActive={!isCheckbox}/>
      {type === 'textarea' ?
        <Textarea
          {...field.input}
          type={field.type || 'text'}
          id={id}
          minRows={2}
          maxRows={8}
          placeholder={field.placeholder}
          className={className}
          onChange={(e) => {
            field.input.onChange(e);
            if (field.customOnChange) {
              field.customOnChange(e);
            }
          }}
          onBlur={(e) => {
            if (field.customOnBlur) {
              field.customOnBlur(e);
            }
          }}
        />
        :
        <input
          {...field.input}
          type={field.type || 'text'}
          id={id}
          placeholder={field.placeholder}
          className={className}
          onChange={(e) => {
            field.input.onChange(e);
            if (field.customOnChange) {
              field.customOnChange(e);
            }
          }}
          onBlur={(e) => {
            if (field.customOnBlur) {
              field.customOnBlur(e);
            }
          }}
        />
      }
      {field.children}
      {isCheckbox && field.label ? <label htmlFor={id}>{spaceBeforeLabel ? '\u00A0' : ''}{field.label}</label> : ''}
    </div>
  );
};